<template>
  <RouterView />
</template>
<script setup>
import { onMounted } from 'vue'
import { useAuthStore } from './stores/auth'

const store = useAuthStore()

onMounted(() => {
  store.initialize()
})
</script>

<style lang="scss">
#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  min-width: 20rem;
  font-size: 1rem;
}
</style>
